/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable @typescript-eslint/naming-convention */
import { RxJsonSchema } from 'rxdb';
import { MigrationManagerService } from '../../migration';
import { WorkspaceDatabaseKeys } from '../workspace-database-keys';
import { AppVariables } from '@shared';

export class DataSchemaBuilder {
	// are those case sensitive
	private dataTypesMappings: { [id: string]: string } = {
		CHAR: 'string',
		NUMERIC: 'string',
		DATE: 'string',
		DATETIME: 'string',
		IMAGE: 'string',
		HYPERLINK: 'string',
		CUSTOM_TYPE_DEPTH: 'number'
	};

	private jsonSchema: RxJsonSchema<any> = {
		primaryKey: 'rxdbidstring',
		version: MigrationManagerService.currentDatabaseVersion,
		properties: {},
		// todo: premium
		indexes: ['rxdbid'],
		type: 'object',
		description: 'This is dynamically Build'
	};

	public addProperty(name: string, type: string): DataSchemaBuilder {
		if (name === WorkspaceDatabaseKeys.columns.depthFrom || name === WorkspaceDatabaseKeys.columns.depthTo) {
			this.jsonSchema.properties[name] = {
				type: this.dataTypesMappings.CUSTOM_TYPE_DEPTH
			};

			// for tables with samples
			// we need to get last record in order to suggest next depth_from/depth_to values
			// in RxDB we can sort columns only if there is an index
			if (name === WorkspaceDatabaseKeys.columns.depthTo) {
				// todo: premium need to add multiple of !!  very important
				this.jsonSchema.indexes = this.jsonSchema.indexes.concat(WorkspaceDatabaseKeys.columns.depthTo);
				this.jsonSchema.properties[WorkspaceDatabaseKeys.columns.depthTo] = {
					type: 'number',
					minimum: -AppVariables.MAXIMUM_NUMBER_OF_RECORDS,
					maximum: AppVariables.MAXIMUM_NUMBER_OF_RECORDS,
					multipleOf: AppVariables.NUMBER_RECORDS_PRECISION
				};
			}

			return this;
		}

		this.jsonSchema.properties[name] = {
			type: this.dataTypesMappings[type]
		};
		return this;
	}

	//todo: after updating to Rxdb 7, we need to add a new primary key that is of type string
	public buildWithLocalRxdbProperties(): RxJsonSchema<any> {
		this.jsonSchema.properties['rxdbid'] = {
			type: 'number',
			minimum: 0,
			maximum: AppVariables.MAXIMUM_NUMBER_OF_RECORDS,
			multipleOf: 0.01
		};

		this.jsonSchema.properties['rxdbidstring'] = {
			type: 'string',
			maxLength: AppVariables.PRIMARY_KEYS_MAX_LENGTH
		};

		this.jsonSchema.properties['isDeleted'] = {
			type: 'boolean'
		};

		return this.jsonSchema;
	}
}
